export default {

     // Formulaire de recherche commande
    get_fref: state => {return state.fref},
    get_fncde: state => {return state.fncde},
    get_fmod: state => {return state.fmod},
    get_fcol: state => {return state.fcol},
    get_fdatecdemin: state => {return state.fdate_cdemin},
    get_fdatecdemax: state => {return state.fdate_cdemax},
    get_fstatut: state => {return state.fstatut},
    get_research: state => {return state.launch_research},
    get_reset_order_list: state => {return state.reset_order_list},
    
    get_pnocde: state => {return state.pnocde},

    // Formulaire de recherche détail d'une ligne de commande
    get_detail_fref: state => {return state.detail_fref},
    get_detail_fmod: state => {return state.detail_fmod},
    get_detail_fcol: state => {return state.detail_fcol},
    get_detail_ftail: state => {return state.detail_ftail},
    get_detail_research: state => {return state.launch_detail_research},
};